import { FC } from 'react';

import { toast } from 'sonner';
import { BaseModal } from 'wbs-components-lib';

import { useAssignReferralMutation } from '@services';

import { REFERRAL_ASSIGN_DEFAULT_VALUES } from '../constants';
import { ReferralAssignForm, ReferralAssignFormValues } from '../ReferralAssignForm';

import { ReferralAssignModalProps } from './types';

export const ReferralAssignModal: FC<ReferralAssignModalProps> = ({ isOpened, handleClose, userId }) => {
  const [assignReferralMutation, { isLoading: isReferralAssigning }] = useAssignReferralMutation();

  const handleAssigningReferral = async (formValues: ReferralAssignFormValues) => {
    await assignReferralMutation({ inviterId: userId, ...formValues }).unwrap();

    toast.success('Referral has been assigned successfully!');

    handleClose();
  };

  return (
    <BaseModal headerTitle="Assign Referral" isOpened={isOpened} handleClose={handleClose} isFooterNeeded={false}>
      <ReferralAssignForm
        initialValues={REFERRAL_ASSIGN_DEFAULT_VALUES}
        isSubmitting={isReferralAssigning}
        onSubmit={handleAssigningReferral}
      />
    </BaseModal>
  );
};
